import React, { Fragment, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/auth";
import setAuthToken from "./utilities/setAuthToken";

import "./styles/App.css";

import Home from "./components/pages/Home";
import Landing from "./components/pages/Landing";
import Mentors from "./components/pages/Mentors";
import About from "./components/pages/About";
import Register from "./components/pages/Register";
import ForgotPassword from "./components/pages/ForgotPassword";
import imeCalendar from "./components/pages/imeCalendar";
import Employers from "./components/pages/Employers";
import Jobs from "./components/pages/Jobs";
import Setup from "./components/pages/Setup";
import Profile from "./components/pages/Profile";
import EditProfile from "./components/pages/EditProfile";
import CompanyProfile from "./components/pages/CompanyProfile";
import SetupProfile from "./components/pages/SetupProfile";
import SetupProfileUsers from "./components/pages/SetupProfileUsers";
import SetupMentor from "./components/pages/SetupMentor";
import SetupMentorUsers from "./components/pages/SetupMentorUsers";
import SetupEmployer from "./components/pages/SetupEmployer";
import SetupEmployerUsers from "./components/pages/SetupEmployerUsers";
import VRTours from "./components/pages/VRTours";
import Trending from "./components/pages/Trending";
import EmployerSpotlight from "./components/pages/EmployerSpotlight";
import LiveOnIME from "./components/pages/LiveOnIME";
import IndustryOfWeek from "./components/pages/IndustryOfWeek";
import LiveOnIMEJobs from "./components/pages/LiveOnIMEJobs";
import LiveOnIMEMentors from "./components/pages/LiveOnIMEMentors";
import LiveOnIMEDiscussions from "./components/pages/LiveOnIMEDiscussions";
import JobStream from "./components/pages/JobStream";
import MentorStream from "./components/pages/MentorStream";
import DiscussionStream from "./components/pages/DiscussionStream";
import DiscussionLiveStream from "./components/pages/DiscussionLiveStream";
import Course from "./components/pages/Course";
import VRTour from "./components/pages/VRTour";
import Advertising from "./components/pages/Advertising";
import UserArticles from "./components/pages/UserArticles";
import CreateArticle from "./components/pages/CreateArticle";
import CreateDiscussion from "./components/pages/CreateDiscussion";
import CreateCourse from "./components/pages/CreateCourse";
import Content from "./components/pages/Content";
import Purchases from "./components/pages/Purchases";
import Users from "./components/pages/Users";
import ManageApplications from "./components/pages/ManageApplications";
import CreateJobPost from "./components/pages/CreateJobPost";
import CreateTour from "./components/pages/CreateTour";
import Settings from "./components/pages/Settings";
import MentorLiveStream from "./components/pages/MentorLiveStream";
import CampaignLiveStream from "./components/pages/CampaignLiveStream";
import EmployerLiveStream from "./components/pages/EmployerLiveStream";
import IMEDiscussion from "./components/pages/IMEDiscussion";
import DiscussionParticipants from "./components/pages/DiscussionParticipants";
import ParticipantPanel from "./components/pages/JoinPanelDiscussion";
import Subscriptions from "./components/pages/Subscriptions";
import Dashboard from "./components/pages/Dashboard";
import ScrollToTop from "./components/layout/IME/ScrollToTop";
import CampaignCommunity from "./components/pages/CampaignCommunity";
import Agreement from "./components/pages/Agreement";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Fragment>
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/agreement" component={Agreement} />
            <Route exact path="/register" component={Register} />
            <Route
              exact
              path="/industryofweek/:industryname"
              component={IndustryOfWeek}
            />
            <Route exact path="/liveonime" component={LiveOnIME} />
            <Route
              exact
              path="/liveonime/employers"
              component={LiveOnIMEJobs}
            />
            <Route
              exact
              path="/liveonime/employers/:channelid"
              component={JobStream}
            />
            <Route
              exact
              path="/liveonime/mentors"
              component={LiveOnIMEMentors}
            />
            <Route
              exact
              path="/liveonime/mentors/:channelid"
              component={MentorStream}
            />
            <Route
              exact
              path="/liveonime/mentors/:channelid/live"
              component={MentorLiveStream}
            />
            <Route
              exact
              path="/liveonime/Roland/live"
              component={CampaignLiveStream}
            />
            <Route
              exact
              path="/liveonime/employers/:channelid/live"
              component={EmployerLiveStream}
            />
            <Route
              exact
              path="/liveonime/mentors/courses/:channelid/:course_name/:course_id"
              component={Course}
            />
            <Route
              exact
              path="/liveonime/innovators"
              component={LiveOnIMEDiscussions}
            />
            <Route
              exact
              path="/liveonime/innovators/:channelid"
              component={DiscussionStream}
            />
            <Route
              exact
              path="/liveonime/innovators/:channelid/live"
              component={DiscussionLiveStream}
            />
            <Route
              exact
              path="/liveonime/discussions/imediscussion"
              component={IMEDiscussion}
            />
            <Route
              exact
              path="/liveonime/innovators/:channelid/link"
              component={DiscussionParticipants}
            />
            <Route
              exact
              path="/username/panel/link"
              component={ParticipantPanel}
            />
            <Route
              exact
              path="/employerspotlight/:companyname"
              component={EmployerSpotlight}
            />
            <Route exact path="/vrtours" component={VRTours} />
            <Route exact path="/vrtours/:channelid/:_id" component={VRTour} />
            <Route exact path="/trending" component={Trending} />
            <Route exact path="/about" component={About} />
            <Route exact path="/advertising" component={Advertising} />
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/calendar" component={imeCalendar} />
            <Route exact path="/mentors" component={Mentors} />
            <Route exact path="/employers" component={Employers} />
            <Route exact path="/setup" component={Setup} />
            <Route
              exact
              path="/:channelid/setupprofile"
              component={SetupProfile}
            />
            <Route
              exact
              path="/:channelid/setupusers"
              component={SetupProfileUsers}
            />
            <Route
              exact
              path="/:channelid/setupmentors"
              component={SetupMentor}
            />
            <Route
              exact
              path="/setupmentorusers"
              component={SetupMentorUsers}
            />
            <Route
              exact
              path="/setupemployers/:channelid"
              component={SetupEmployer}
            />
            <Route
              exact
              path="/setupemployerusers"
              component={SetupEmployerUsers}
            />
            <Route
              exact
              path="/:channelid/create_article"
              component={CreateArticle}
            />
            <Route
              exact
              path="/:channelid/create_discussion"
              component={CreateDiscussion}
            />
            <Route
              exact
              path="/:channelid/create_course"
              component={CreateCourse}
            />
            <Route
              exact
              path="/:channelid/create_job_post"
              component={CreateJobPost}
            />
            <Route
              exact
              path="/:channelid/create_vrtour"
              component={CreateTour}
            />
            <Route exact path="/companyprofile" component={CompanyProfile} />
            <Route exact path="/:channelid/users" component={Users} />
            <Route
              exact
              path="/:channelid/subscriptions"
              component={Subscriptions}
            />
            <Route exact path="/jobs" component={Jobs} />
            {/* <Route exact path="/:channelid" component={Profile} /> */}
            <Route exact path="/:channelid" component={CampaignCommunity} />
            <Route exact path="/:channelid/edit" component={EditProfile} />
            <Route exact path="/:channelid/articles" component={UserArticles} />
            <Route exact path="/:channelid/purchases" component={Purchases} />
            <Route exact path="/:channelid/settings" component={Settings} />
            <Route exact path="/:channelid/dashboard" component={Dashboard} />
            <Route exact path="/:channelid/content" component={Content} />
            <Route
              exact
              path="/:channelid/manage_applications"
              component={ManageApplications}
            />
          </Switch>
        </Fragment>
      </Router>
    </Provider>
  );
};

export default App;
